import React from 'react';
import 'swiper/swiper-bundle.css';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import Dashboard from './pages/Dashboard/Dashboard';
import Assessments from './pages/Assessments/Assessments';
import CompletedAssessments from './pages/CompletedAssessments/CompletedAssessments';
import Courses from './pages/Courses/Courses';
import CourseDetails from './pages/CourseDetails/CourseDetails';
import StartLearning from './pages/StartLearning/StartLearning';
import Jobs from './pages/Jobs/Jobs';
import ApplyJob from './pages/ApplyJob/ApplyJob';
import AssessmentsOverview from './pages/AssessmentsOverview/AssessmentsOverview';
import AssessmentsForm from './pages/AssessmentsForm/AssessmentsForm';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BlogDetail from './components/Landing/BlogDetail';
import Certificate from './components/Landing/Certificate';
import JobResults from './components/Landing/JobResults';
import AssessmentResult from './pages/AssessmentResult/AssessmentResult';
import AssessmentResultView from './pages/AssessmentResultView/AssessmentResultView';
import AssessmentDetailReport from './pages/AssessmentResult/AssessmentDetailReport';
import BookADemo from './pages/BookADemo/BookADemo';
import MainContent from './components/Dashboard-new/MainContent';
import Home from './pages/HomeNew/Home';
import AboutNew from './pages/Home/AboutNew';
import TermsandCondition from './pages/Home/TermsandCondition';
import PrivacyPolicy from './pages/Home/PrivacyPolicy';
import SolutionNew from './pages/Home/Solution';
import ProductNew from './pages/Home/Products';
import Pricing from './pages/Home/Pricing';
import JobApply from './pages/JobApply/JobApply';
import HowItWorks from './pages/HowItWorks/HowItWorks';
import ScheduleDemo from './pages/ScheduleDemo/ScheduleDemo';
import About from './pages/About/About';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/job-apply/:jobid" element={<JobApply />} />
        <Route path="/our-story" element={<AboutNew />} />
        <Route path="/terms-and-conditions" element={<TermsandCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/products" element={<ProductNew />} />
        <Route path="/solutions" element={<SolutionNew />} />
        <Route path="/commercials" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/MainContent" element={<MainContent />} />
        <Route path="/assessments" element={<Assessments />} />
        <Route path="/completed-assessments" element={<CompletedAssessments />} />
        <Route path="/results" element={<JobResults />} />
        <Route path="/assessment-overview/:id" element={<AssessmentsOverview />} />
        <Route path="/assessments/result" element={<AssessmentResult />} />
        <Route path="/assessments/result-view" element={<AssessmentResultView />} />
        <Route path="/assessments/details-report" element={<AssessmentDetailReport />} />
        <Route path="/assessment-form" element={<AssessmentsForm />} />
        <Route path="/blogs/:blogId" element={<BlogDetail />} />
        <Route path="/certificate" element={<Certificate />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course-details" element={<CourseDetails />} />
        <Route path="/start-learning" element={<StartLearning />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/apply-job" element={<ApplyJob />} />
        <Route path="/book-a-demo" element={<BookADemo />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/schedule-demo" element={<ScheduleDemo />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
